<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.5 5v11.67a1.67 1.67 0 0 0 1.67 1.66h11.66a1.67 1.67 0 0 0 1.67-1.66V5a1.67 1.67 0 0 0-1.67-1.67h-1.66V1.67H12.5v1.66h-5V1.67H5.83v1.66H4.17A1.67 1.67 0 0 0 2.5 5Zm13.33 11.67H4.17v-10h11.66v10Z"
    fill="currentColor"
  />
</svg>
